/**
 * RequestInMeetingService
 * Service for RequestInMeeting entity operations
 * Route: api/requestinmeetings
 * Controller: RequestInMeetingsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * RequestInMeetingService
 * Handles request in meeting CRUD operations
 * Maps to /api/requestinmeetings endpoint
 */
export class RequestInMeetingService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RequestInMeetingService.DEFAULT_SERVICE_PATH,
            basePath: RequestInMeetingService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
RequestInMeetingService.DEFAULT_SERVICE_PATH = 'meetings';
RequestInMeetingService.BASE_PATH = 'api/requestinmeetings';
//# sourceMappingURL=RequestInMeetingService.js.map